import { CanActivateFn } from '@angular/router';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { ApidataService } from './apidata.service';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const apirequest = inject(ApidataService);

  const roleUser = localStorage.getItem('role') === '1';
  const isLoggedIn = apirequest.isLoggedIn();
  const loginToken = localStorage.getItem('id_token') || localStorage.getItem('loginid') || localStorage.getItem('authentication_token');
  const hasCurrentUser = JSON.parse(localStorage.getItem('currentUser') || 'false');

  // Check if any login condition is met
  if (isLoggedIn || loginToken || roleUser || hasCurrentUser) {
    return true; // Allow navigation
  }

  // Redirect to signin page if not logged in
  router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
  return false; // Block navigation
};
